export default __webpack_public_path__ + "static/media/Wd.6f0120c4.jpg";